export const Experiments = {
  PremiumBlockUoU: 'specs.invoices.PremiumBlockUoU',
  PriceQuoteTaxedLineTotals: 'specs.pricequotes.taxedLineTotals',
  BmHarmonyTheme: 'bmHarmonyTheme',
} as const;
